import { type NexusApiActionDef } from "./action-def.types";
import { deleteOutput, listOutput, num, obj, str } from "./output-format.builders";
import {
  WORKFLOW_CREATABLE_DEPLOYMENT_TYPE_OPTIONS,
  WORKFLOW_CREATABLE_DEPLOYMENT_TYPES
} from "./workflow-creatable-deployment-types";

export const deploymentActions: NexusApiActionDef[] = [
  {
    action: "deployments.list",
    label: "List Deployments",
    description: "List all deployments",
    inputSchema: {},
    outputFormat: listOutput("deployments")
  },
  {
    action: "deployments.get",
    label: "Get Deployment",
    description: "Get deployment details",
    inputSchema: {
      deploymentId: { type: "string", description: "Deployment ID" }
    },
    outputFormat: obj("Deployment details")
  },
  {
    action: "deployments.create",
    label: "Create Deployment",
    description: "Create a new deployment",
    inputSchema: {
      name: { type: "string", description: "Deployment name" },
      type: {
        type: "string",
        description:
          "Deployment type. Channels that need a phone number, an OAuth connection or channel settings (WhatsApp, SMS, voice, Gmail, Outlook, Teams, Telegram, the web widget) are created in the console.",
        constraints: {
          allowedValues: [...WORKFLOW_CREATABLE_DEPLOYMENT_TYPES],
          allowedOptions: WORKFLOW_CREATABLE_DEPLOYMENT_TYPE_OPTIONS
        }
      },
      agentId: { type: "string", description: "Agent ID (optional)" },
      description: { type: "string", description: "Description (optional)" }
    },
    outputFormat: obj("Created deployment")
  },
  {
    action: "deployments.update",
    label: "Update Deployment",
    description: "Update a deployment",
    inputSchema: {
      deploymentId: { type: "string", description: "Deployment ID" },
      name: { type: "string", description: "Name (optional)" },
      description: { type: "string", description: "Description (optional)" },
      isActive: { type: "boolean", description: "Active status (optional)" }
    },
    outputFormat: obj("Updated deployment")
  },
  {
    action: "deployments.delete",
    label: "Delete Deployment",
    description: "Delete a deployment",
    inputSchema: {
      deploymentId: { type: "string", description: "Deployment ID" }
    },
    outputFormat: deleteOutput
  },
  {
    action: "deployments.duplicate",
    label: "Duplicate Deployment",
    description: "Duplicate a deployment",
    inputSchema: {
      deploymentId: { type: "string", description: "Deployment ID to duplicate" }
    },
    outputFormat: obj("Duplicated deployment")
  },
  {
    action: "deployments.getStatistics",
    label: "Get Statistics",
    description: "Get deployment statistics",
    inputSchema: {
      deploymentId: { type: "string", description: "Deployment ID" }
    },
    outputFormat: obj("Statistics", {
      deploymentId: str("Deployment ID"),
      totalSessions: num("Total sessions")
    })
  }
];
